const $$splitPendingComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/index.tsx?tsr-split=pendingComponent');
const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ZnglyVideosFrontendQuery, type ZnglyVideos_Frontend_Pagination_Fragment$key, type ZnglyVideos_Frontend_Query } from '@/graphql/queries/ZnglyVideo.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { ZnglyVideoQueryTypeEnum } from '@/graphql/types';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import type { DeepPick } from 'ts-essentials';
import { z } from 'zod';
type Props = {
  isFallback?: boolean;
} & Partial<ReturnType<typeof usePaginationFragment<ZnglyVideos_Frontend_Query, ZnglyVideos_Frontend_Pagination_Fragment$key>>>;
const searchSchema = z.object({
  s: z.string().optional().nullable().catch(null),
  c: z.string().optional().nullable().catch(null),
  categories: z.array(z.string()).optional().nullable().catch(null)
});
type SearchSchema = z.infer<typeof searchSchema>;
type LoaderDeps = DeepPick<SearchSchema, {
  s: never;
  categories: never;
}>;
export const Route = createFileRoute('/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: (params): SearchSchema => searchSchema.parse(params),
  onEnter: ({
    search
  }) => {
    let pageType: AppStore['pageType'] = 'front_page';
    let barView: AppStore['barView'] = 'list';
    if (search?.s) {
      barView = 'grid';
      pageType = 'search';
    } else if (search?.categories?.length) pageType = 'category';
    useAppStore.setState({
      barView,
      pageType,
      barTitle: 'Suggested Content'
    });
  },
  onLeave: () => {
    useAppStore.setState({
      catalogLoadMore: undefined,
      barView: 'list'
    });
  },
  pendingComponent: lazyRouteComponent($$splitPendingComponentImporter, 'pendingComponent'),
  loaderDeps: ({
    search
  }) => {
    return {
      s: search?.s,
      categories: search?.categories
    } as LoaderDeps;
  },
  loader: ctx => {
    const search = ctx.location.search as SearchSchema;
    const deps = ctx.deps as LoaderDeps;
    return loadQuery<ZnglyVideos_Frontend_Query>(RelayEnvironment, ZnglyVideosFrontendQuery, {
      first: 24,
      where: {
        queryType: ZnglyVideoQueryTypeEnum.Homepage,
        ...(deps?.categories && {
          categoryIn: deps.categories
        }),
        ...(deps?.s && {
          search: deps.s
        }),
        // we only want this on the first load
        // the c param tell the query to return the selected node first
        ...(search?.c && ctx.cause === 'enter' ? {
          c: search.c
        } : {})
      }
    }, {
      fetchPolicy: 'store-or-network'
    });
  },
  shouldReload(match) {
    // if there is a "c" param, we don't want to reload
    if (!!(match.location.search as SearchSchema)?.c) {
      return false;
    }
    return true;
  }
});